import { render } from "./ContactUS.vue?vue&type=template&id=67702c18&scoped=true"
import script from "./ContactUS.vue?vue&type=script&lang=js"
export * from "./ContactUS.vue?vue&type=script&lang=js"

import "./ContactUS.vue?vue&type=style&index=0&id=67702c18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67702c18"]])

export default __exports__